import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { CfaService } from "../services/cfa.service";
import { AuthService } from "../services/auth.service";
import { firstValueFrom, filter } from "rxjs";

@Injectable({ providedIn: "root" })
export class OnBoardingPending {
    constructor(
        private readonly _router: Router,
        private readonly _cfaService: CfaService,
        private readonly _authService: AuthService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            await firstValueFrom(this._authService.checkAuthStatusComplete$.pipe(
                filter(v => v === true),
            ));
            //not loggedIn can access
            if (!this._authService.user) {
                return true;
            }
            //loggedIn but with no onboardingCompleted can also access
            let finalized = await firstValueFrom(this._cfaService.onboardingFinalize());
            if (finalized.status === "needs-onboarding") {
                return true;
            } else if (finalized.status === "completed") {
                return this._router.navigate(["/"]);
            }
            //for all other states, wait for completion and then go to /author-page 
            while (finalized.status !== "completed") {
                finalized = await firstValueFrom(this._cfaService.onboardingFinalize());
                if (finalized.status !== "completed") {
                    await new Promise((resolve) => setTimeout(resolve, 300));
                }
            }
            return this._router.navigate(["/author-page"]);
        } catch (e) {
            console.error(e);
            this._authService.logout();
            return false;
        }
    }
}
